import { api, isTruthy } from 'common';

/**
 * FIXME: This is a temporary solution to get the filter options.
 * Endpoints or Enum's must be created to populate the filter options.
 * This must be fixed before implementing pagination on this page.
 */
export function mapConnectorsPageFilterOptions(connections: api.Connection.Connection[]) {
  const sources = new Set<string>();
  const destinations = new Set<string>();
  const methods = new Set<string>();
  const dataTypes = new Set<string>();

  for (const connection of connections) {
    if (isTruthy(connection.source)) {
      sources.add(connection.source);
    }
    if (isTruthy(connection.destination)) {
      destinations.add(connection.destination);
    }
    if (isTruthy(connection.method)) {
      methods.add(connection.method);
    }
    if (isTruthy(connection.dataType)) {
      dataTypes.add(connection.dataType);
    }
  }

  return {
    source: [...sources],
    destination: [...destinations],
    connectivity: [...methods],
    format: [...dataTypes],
  };
}

export const connectorDetailsPathByConnectionType = {
  [api.Connection.ConnectionType.Api]: '/connections/api',
  [api.Connection.ConnectionType.Sftp]: '/connections/sftp',
  [api.Connection.ConnectionType.InterfaceEngine]: '/connections/interface-engine',
};

export const connectionNameByConnectionType = {
  [api.Connection.ConnectionType.Api]: 'API',
  [api.Connection.ConnectionType.Sftp]: 'SFTP',
  [api.Connection.ConnectionType.InterfaceEngine]: 'Interface Engine',
};

export enum ConnectorsDetailsMode {
  Drawer = 'drawer',
  Page = 'page',
}
